module.exports = __webpack_public_path__ + "static/media/rest.05c0b9b4.png";